import type { Transition, Variants } from "motion/react";
import type { AddPhoneWizardStep } from "./add-phone-wizard-state.js";

export const ADD_PHONE_STEP_OFFSET_PX = 14;

export const ADD_PHONE_STEP_ORDER: Record<AddPhoneWizardStep, number> = {
  BUSINESS_PROFILE: 0,
  PHONE_NUMBER: 1,
  VERIFICATION_METHOD: 2,
  VERIFICATION_CODE: 2,
  CONNECTING: 3,
  READY_TO_ATTACH: 3,
  REGISTRATION_PENDING: 3,
  SUCCESS: 3,
};

export type AddPhoneStepDirection = 1 | -1;

export function addPhoneStepDirection(
  from: AddPhoneWizardStep,
  to: AddPhoneWizardStep,
): AddPhoneStepDirection {
  const delta = ADD_PHONE_STEP_ORDER[to] - ADD_PHONE_STEP_ORDER[from];
  return delta >= 0 ? 1 : -1;
}

export function addPhoneStepMotion(options: {
  isRtl: boolean;
  reduceMotion: boolean;
}): { variants: Variants; transition: Transition } {
  if (options.reduceMotion) {
    return {
      variants: {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
      },
      transition: { duration: 0 },
    };
  }

  const rtlFactor = options.isRtl ? -1 : 1;

  return {
    variants: {
      initial: (direction: AddPhoneStepDirection) => ({
        opacity: 0,
        x: direction * rtlFactor * ADD_PHONE_STEP_OFFSET_PX,
      }),
      animate: { opacity: 1, x: 0 },
      exit: (direction: AddPhoneStepDirection) => ({
        opacity: 0,
        x: direction * rtlFactor * -ADD_PHONE_STEP_OFFSET_PX,
      }),
    },
    transition: { duration: 0.22, ease: [0.22, 1, 0.36, 1] },
  };
}
